<button class="close modalClose" mat-button (click)="onNoClick()" tabindex="-1">
  X
</button>
<h1 mat-dialog-title class="previewTitle">&nbsp;</h1>
<div mat-dialog-content>
  <mat-form-field
    [formGroup]="fieldForm"
    id="searchDataPoints"
    style="
      width: 100%;
      height: 40px;
      font-size: 14px;
      margin-top: 10px !important;
    "
    appearance="outline"
  >
    <input
      matInput
      name="field"
      aria-label="Search for a data field"
      placeholder="Search Fields"
      autocomplete="off"
      (keyup)="applyFilter($event)"
      formControlName="field"
      style="margin-left: 10px"
    />

    <fa-icon
      [icon]="faSearch"
      style="font-size: 16px; margin-right: 5px"
      matPrefix
      mat-button
      class="filterMenu"
    ></fa-icon>
  </mat-form-field>

  <mat-drawer-container class="search-container">
    <mat-drawer
      mode="side"
      position="start"
      opened
      class="side"
      [disableClose]="true"
    >
      <h2 class="header">Check collections to view available fields</h2>
      <!-- Master Checkbox -->
      <ul class="list-group">
        <li class="list-group-item">
          <!--Master Expand/ Collapse Arrow  -->
          <span (click)="expandCollapseAll(datasets)">
            <fa-icon
              *ngIf="datasets.isAllCollapsed; else isCollapsed"
              [icon]="faChevronRight"
              style="margin-right: 7px; cursor: pointer"
            ></fa-icon>
            <ng-template #isCollapsed
              ><fa-icon
                [icon]="faChevronDown"
                style="margin-right: 7px; cursor: pointer"
              ></fa-icon
            ></ng-template>
          </span>

          <span
            (click)="selectUnselectAll(datasets)"
            style="cursor: pointer; font-weight: bold"
          >
            <span *ngIf="datasets.isAllSelected; else noneSelected">
              <input
                type="checkbox"
                [checked]="true"
                style="margin-right: 8px; cursor: pointer"
              />
              Unselect All
            </span>
            <ng-template #noneSelected
              ><input
                type="checkbox"
                [checked]="false"
                style="margin-right: 8px; cursor: pointer"
              />
              Select All
            </ng-template>
          </span>
        </li>
      </ul>
      <ul class="list-group">
        <!-- Parent Item -->
        <li class="list-group-item" *ngFor="let item of datasets">
          <!-- Parent Checkbox -->
          <!-- Parent Arrow -->
          <span (click)="expandCollapse(item)">
            <fa-icon
              [icon]="faChevronRight"
              *ngIf="item.isClosed; else isCollapsed"
            ></fa-icon>
            <ng-template #isCollapsed>
              <fa-icon [icon]="faChevronDown"></fa-icon>
            </ng-template> </span
          >&nbsp;

          <input
            type="checkbox"
            [(ngModel)]="item.isSelected"
            name="list_name"
            name="{{ item.id }}"
            (ngModelChange)="parentCheck(item)"
            color="primary"
          />

          &nbsp;
          <span class="group_header">{{ item.name }}</span>

          <div class="child-list" [hidden]="item.isClosed">
            <ul class="list-group level-two">
              <!-- Child Item -->
              <li
                class="list-group-item level-two"
                *ngFor="let itemChild of item.dataSets.data"
              >
                <!-- Child Checkbox -->
                <input
                  type="checkbox"
                  [(ngModel)]="itemChild.isSelected"
                  name="list_name_child"
                  name="{{ itemChild.id }}"
                  color="primary"
                  (ngModelChange)="childCheck(item, item.dataSets.data)"
                />

                &nbsp;
                {{ itemChild.name }}
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </mat-drawer>

    <mat-drawer-content style="background-color: #fff !important">
      <div class="spinner-item">
        <mat-progress-spinner
          [mode]="'indeterminate'"
          [diameter]="75"
          [strokeWidth]="2"
          *ngIf="loading"
        >
        </mat-progress-spinner>
      </div>

      <div [hidden]="!error" class="initialSearch">
        {{ error }}
      </div>
      <div [hidden]="!showData">
        <div [hidden]="dataSource && dataSource.length <= 0">
          <table mat-table [dataSource]="dataSource" matSort id="dataTable">
            <!-- Checkbox Column -->
            <ng-container matColumnDef="select">
              <th
                mat-header-cell
                *matHeaderCellDef
                style="font-size: 10px; line-height: 13px"
              >
                Select Fields
              </th>
              <td mat-cell *matCellDef="let row">
                <mat-checkbox
                  (click)="$event.stopPropagation()"
                  (change)="$event ? selection.toggle(row) : null"
                  [checked]="selection.isSelected(row)"
                  color="primary"
                >
                </mat-checkbox>
              </td>
            </ng-container>

            <!-- Type Column -->
            <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef>Type</th>
              <td mat-cell *matCellDef="let element">
                <app-datapoint-icons
                  style="margin: 10px"
                  [type]="element.type"
                ></app-datapoint-icons>
              </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
              <td mat-cell *matCellDef="let element">{{ element.name }}</td>
            </ng-container>

            <!-- dataset Column -->
            <ng-container matColumnDef="dataset">
              <th mat-header-cell *matHeaderCellDef mat-sort-header="dataset">
                Collection
              </th>
              <td mat-cell *matCellDef="let element">
                <ng-container *ngIf="element.stream_dir_data; else defaultView">
                  <ng-container *ngIf="element.stream_dir_data === 'up'">
                    {{ element.dataSet?.data?.name }} > {{ element.linkedDataset?.data?.name }}
                  </ng-container>
                  <ng-container *ngIf="element.stream_dir_data === 'down'">
                    {{ element.linkedDataset?.data?.name }} > {{ element.dataSet?.data?.name }}
                  </ng-container>
                </ng-container>
                <ng-template #defaultView>
                  {{ element.dataSet?.data?.name }}
                </ng-template>
              </td>
            </ng-container>

            <tr
              mat-header-row
              *matHeaderRowDef="displayedColumns; sticky: true"
            ></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns"
              (click)="selection.toggle(row)"
            ></tr>
          </table>

          <mat-paginator
            [pageSize]="50"
            [pageSizeOptions]="[10, 20, 50, 100, 500]"
            showFirstLastButtons
          ></mat-paginator>
        </div>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
</div>

<div mat-dialog-actions align="end" style="display: block">
  <button mat-button mat-dialog-close class="button_small cancel">
    cancel
  </button>
  <button
    mat-button
    class="button_small"
    (click)="apply()"
    [disabled]="itemsSelected() <= 0"
  >
    apply ( {{ itemsSelected() }} )
  </button>
</div>
